// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"0efd18a4","703":"b761b2a8"}[chunkId] + ".chunk.js";
};